"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unescapeHTML = exports.escapeHTML = exports.isEmptyString = exports.trimAsterisk = exports.capitalizeEach = exports.capitalizeOnly = exports.capitalize = void 0;
const capitalize = (value) => `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}`;
exports.capitalize = capitalize;
const capitalizeOnly = (value) => `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
exports.capitalizeOnly = capitalizeOnly;
const capitalizeEach = (value) => value
    .split(' ')
    .map(word => `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`)
    .join(' ');
exports.capitalizeEach = capitalizeEach;
const trimAsterisk = (value) => value.replace(/\*$/, '');
exports.trimAsterisk = trimAsterisk;
// Checks whether the string is just an empty string (as opposed to null or undefined)
const isEmptyString = (value) => typeof value === 'string' && value.trim() === '';
exports.isEmptyString = isEmptyString;
const escapeHTML = (str) => str.replace(/[&<>'"]/g, tag => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '"': '&quot;',
}[tag] || tag));
exports.escapeHTML = escapeHTML;
const unescapeHTML = (str) => str.replace(/&amp;|&lt;|&gt;|&#39;|&quot;/g, tag => ({
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&#39;': "'",
    '&quot;': '"',
}[tag] || tag));
exports.unescapeHTML = unescapeHTML;
//# sourceMappingURL=StringUtil.js.map